const sitesMap = new Map();

//#region GB
//-----------------
sitesMap.set('gb/en', {
  siteName: 'support-gb-en',
  lang: 'en',
  dictionary: 'en-GB',
  country: 'gb',
});
//#endregion

//#region IE
//-----------------

sitesMap.set('ie/en', {
  siteName: 'support-ie-en',
  lang: 'en',
  dictionary: 'en-IE',
  country: 'ie',
});
//#endregion

//#region AU
//-----------------

sitesMap.set('au/en', {
  siteName: 'support-au-en',
  lang: 'en',
  dictionary: 'en-AU',
  country: 'au',
});
//#endregion

//#region NZ
//-----------------

sitesMap.set('nz/en', {
  siteName: 'support-nz-en',
  lang: 'en',
  dictionary: 'en-NZ',
  country: 'nz',
});
//#endregion

//#region CA
//-----------------

sitesMap.set('ca/en', {
  siteName: 'support-ca-en',
  lang: 'en',
  dictionary: 'en-CA',
  country: 'ca',
});
//#endregion

//#region US
//-----------------

sitesMap.set('us/en', {
  siteName: 'support-us-en',
  lang: 'en',
  dictionary: 'en ',
  country: 'us',
});

// Fallback for paths that don't match a country/language segment (e.g. /robots.txt,
// /favicon.ico, /). US is the only live Support market, so it's the correct default.
sitesMap.set('default', {
  siteName: 'support-us-en',
  lang: 'en',
  dictionary: 'en ',
  country: 'us',
});
//#endregion

//#region italian
//-----------------

sitesMap.set('it/en', {
  siteName: 'support-it-en',
  lang: 'en',
  dictionary: 'en',
  country: 'it',
});

sitesMap.set('it/it', {
  siteName: 'support-it-it',
  lang: 'it-IT',
  dictionary: 'it-IT',
  country: 'it',
});

//#endregion

//#region korea
//-----------------

sitesMap.set('kr/en', {
  siteName: 'support-kr-en',
  lang: 'en',
  dictionary: 'en',
  country: 'kr',
});

sitesMap.set('kr/ko', {
  siteName: 'support-kr-ko',
  lang: 'ko-KR',
  dictionary: 'ko-KR',
  country: 'kr',
});

//#endregion

//#region japan
//-----------------

sitesMap.set('jp/en', {
  siteName: 'support-jp-en',
  lang: 'en',
  dictionary: 'en',
  country: 'jp',
});

sitesMap.set('jp/ja', {
  siteName: 'support-jp-ja',
  lang: 'ja-JP',
  dictionary: 'ja-JP',
  country: 'jp',
});

//#endregion

//#region france
//-----------------

sitesMap.set('fr/en', {
  siteName: 'support-fr-en',
  lang: 'en',
  dictionary: 'en',
  country: 'fr',
});

sitesMap.set('fr/fr', {
  siteName: 'support-fr-fr',
  lang: 'fr-FR',
  dictionary: 'fr-FR',
  country: 'fr',
});

//#endregion

//#region belgium
//-----------------

sitesMap.set('be/en', {
  siteName: 'support-be-en',
  lang: 'en',
  dictionary: 'en',
  country: 'be',
});

sitesMap.set('be/fr', {
  siteName: 'support-be-fr',
  lang: 'fr-BE',
  dictionary: 'fr-BE',
  country: 'be',
});

sitesMap.set('be/nl', {
  siteName: 'support-be-nl',
  lang: 'nl-BE',
  dictionary: 'nl-BE',
  country: 'be',
});

//#endregion

//#region netherlands
//--------------------

sitesMap.set('nl/en', {
  siteName: 'support-nl-en',
  lang: 'en',
  dictionary: 'en',
  country: 'nl',
});

sitesMap.set('nl/nl', {
  siteName: 'support-nl-nl',
  lang: 'nl-NL',
  dictionary: 'nl-NL',
  country: 'nl',
});

//#endregion

//#region germany
//--------------------

sitesMap.set('de/en', {
  siteName: 'support-de-en',
  lang: 'en',
  dictionary: 'en',
  country: 'de',
});

sitesMap.set('de/de', {
  siteName: 'support-de-de',
  lang: 'de-DE',
  dictionary: 'de-DE',
  country: 'de',
});

//#endregion

// removed from list
// sitesMap.set('at/en', { siteName: 'support-at-en', lang: 'en', country: 'at' });
// sitesMap.set('at/de', { siteName: 'support-at-de', lang: 'at-DE', country: 'at' });
// sitesMap.set('au/de', { siteName: 'support-au-de', lang: 'de-DE', country: 'au' });
// sitesMap.set('be/en', { siteName: 'support-be-en', lang: 'en', country: 'be' });
// sitesMap.set('be/fr', { siteName: 'support-be-fr', lang: 'fr-BE', country: 'be' });
// sitesMap.set('be/nl', { siteName: 'support-be-nl', lang: 'nl-BE', country: 'be' });
// sitesMap.set('br/en', { siteName: 'support-br-en', lang: 'en', country: 'br' });
// sitesMap.set('br/pt', { siteName: 'support-br-pt', lang: 'pt-BR', country: 'br' });
// sitesMap.set('ca/fr', { siteName: 'support-ca-fr', lang: 'fr-CA', country: 'ca' });
// sitesMap.set('ch/en', { siteName: 'support-ch-de-en', lang: 'en', country: 'ch' });
// sitesMap.set('ch/de', { siteName: 'support-ch-de-de', lang: 'de-CH', country: 'ch' });
// sitesMap.set('ch/ef', { siteName: 'support-ch-fr-en', lang: 'en', country: 'ch' });
// sitesMap.set('ch/fr', { siteName: 'support-ch-fr-fr', lang: 'fr-CH', country: 'ch' });
// sitesMap.set('cz/en', { siteName: 'support-cz-en', lang: 'en', country: 'cz' });
// sitesMap.set('cz/cs', { siteName: 'support-cz-cs', lang: 'cs-CZ', country: 'cz' });
// sitesMap.set('de/en', { siteName: 'support-de-en', lang: 'en', country: 'de' });
// sitesMap.set('de/de', { siteName: 'support-de-de', lang: 'de-DE', country: 'de' });
// sitesMap.set('dk/en', { siteName: 'support-dk-en', lang: 'en', country: 'dk' });
// sitesMap.set('dk/da', { siteName: 'support-dk-da', lang: 'da-DK', country: 'dk' });
// sitesMap.set('es/en', { siteName: 'support-es-en', lang: 'en', country: 'es' });
// sitesMap.set('es/es', { siteName: 'support-es-es', lang: 'es-ES', country: 'es' });
// sitesMap.set('fi/en', { siteName: 'support-fi-en', lang: 'en', country: 'fi' });
// sitesMap.set('fi/fi', { siteName: 'support-fi-fi', lang: 'fi-FI', country: 'fi' });
// sitesMap.set('fr/en', { siteName: 'support-fr-en', lang: 'en', country: 'fr' });
// sitesMap.set('fr/fr', { siteName: 'support-fr-fr', lang: 'fr-FR', country: 'fr' });
// sitesMap.set('hk/en', { siteName: 'support-hk-en', lang: 'en', country: 'hk' });
// sitesMap.set('hk/zh', { siteName: 'support-hk-zh', lang: 'zh-HK', country: 'hk' });
// sitesMap.set('hu/en', { siteName: 'support-hu-en', lang: 'en', country: 'hu' });
// sitesMap.set('hu/hu', { siteName: 'support-hu-hu', lang: 'hu-HU', country: 'hu' });
// sitesMap.set('id/en', { siteName: 'support-id-en', lang: 'en', country: 'id' });
// sitesMap.set('id/id', { siteName: 'support-id-id', lang: 'id-ID', country: 'id' });
// sitesMap.set('il/en', { siteName: 'support-il-en', lang: 'en', country: 'il' });
// sitesMap.set('il/he', { siteName: 'support-il-he', lang: 'he-IL', country: 'il' });
// sitesMap.set('in/en', { siteName: 'support-in-en', lang: 'en', country: 'in' });
// sitesMap.set('it/en', { siteName: 'support-it-en', lang: 'en', country: 'it' });
// sitesMap.set('it/it', { siteName: 'support-it-it', lang: 'it-IT', country: 'it' });
// sitesMap.set('jp/en', { siteName: 'support-jp-en', lang: 'en', country: 'jp' });
// sitesMap.set('jp/ja', { siteName: 'support-jp-ja', lang: 'ja-JP', country: 'jp' });
// sitesMap.set('kr/en', { siteName: 'support-kr-en', lang: 'en', country: 'kr' });
// sitesMap.set('kr/ko', { siteName: 'support-kr-ko', lang: 'ko-KR', country: 'kr' });
// sitesMap.set('lk/en', { siteName: 'support-lk-en', lang: 'en', country: 'lk' });
// sitesMap.set('la/en', { siteName: 'support-la-en', lang: 'en', country: 'la' });
// sitesMap.set('la/es', { siteName: 'support-la-es', lang: 'es-AR', country: 'la' });
// sitesMap.set('me/en', { siteName: 'support-me-en', lang: 'en', country: 'me' });
// sitesMap.set('me/ar', { siteName: 'support-me-ar', lang: 'ar-AE', country: 'me' });
// sitesMap.set('my/en', { siteName: 'support-my-en', lang: 'en', country: 'my' });
// sitesMap.set('nl/en', { siteName: 'support-nl-en', lang: 'en', country: 'nl' });
// sitesMap.set('nl/nl', { siteName: 'support-nl-nl', lang: 'nl-NL', country: 'nl' });
// sitesMap.set('no/en', { siteName: 'support-no-en', lang: 'en', country: 'no' });
// sitesMap.set('no/no', { siteName: 'support-no-nb', lang: 'nb-NO', country: 'no' });
// sitesMap.set('pk/en', { siteName: 'support-pk-en', lang: 'en', country: 'pk' });
// sitesMap.set('ph/en', { siteName: 'support-ph-en', lang: 'en', country: 'ph' });
// sitesMap.set('ro/en', { siteName: 'support-ro-en', lang: 'en', country: 'ro' });
// sitesMap.set('ro/ro', { siteName: 'support-ro-ro', lang: 'ro-RO', country: 'ro' });
// sitesMap.set('ru/en', { siteName: 'support-ru-en', lang: 'en', country: 'ru' });
// sitesMap.set('ru/ru', { siteName: 'support-ru-ru', lang: 'ru-RU', country: 'ru' });
// sitesMap.set('sg/en', { siteName: 'support-sg-en', lang: 'en', country: 'sg' });
// sitesMap.set('sv/en', { siteName: 'support-sv-en', lang: 'en', country: 'sv' });
// sitesMap.set('sv/se', { siteName: 'support-sv-se', lang: 'sv-SE', country: 'sv' });
// sitesMap.set('th/en', { siteName: 'support-th-en', lang: 'en', country: 'th' });
// sitesMap.set('th/th', { siteName: 'support-th-th', lang: 'th-TH', country: 'th' });
// sitesMap.set('tr/en', { siteName: 'support-tr-en', lang: 'en', country: 'tr' });
// sitesMap.set('tr/tr', { siteName: 'support-tr-tr', lang: 'tr-TR', country: 'tr' });
// sitesMap.set('tw/en', { siteName: 'support-tw-en', lang: 'en', country: 'tw' });
// sitesMap.set('tw/zh', { siteName: 'support-tw-zh', lang: 'zh-TW', country: 'tw' });
// sitesMap.set('us/es', { siteName: 'support-us-es', lang: 'es-MX', country: 'us' });
// sitesMap.set('vn/en', { siteName: 'support-vn-en', lang: 'en', country: 'vn' });
// sitesMap.set('vn/vi', { siteName: 'support-vn-vi', lang: 'vi-VN', country: 'vn' });

// // non standard
// sitesMap.set('emea/en', {siteName: 'support-emea-en', lang: 'en', country: 'emea'});
// sitesMap.set('mdr/en', {siteName: 'support-mdr-en', lang: 'en', country: 'mdr'});
// sitesMap.set('apac/en', {siteName: 'support-apac-en', lang: 'en', country: 'apac'});
// sitesMap.set('global/en', {siteName: 'support-global-en', lang: 'en', country: 'global'});

// //brand-hub
// sitesMap.set('brand-hub', {siteName: 'brand-hub', lang: 'en', country: 'brand-hub'});

export default function resolveSite(reqUrl) {
  /**
   * Strip virtual path removes the virtual path component before a layoutService request is made, but
   * after the country, site and lang parameters are extracted from the virtual path.
   * @param {string} fPath full path from incoming request
   * @param {string} vPath virtual path component
   * @param {string} sitesObject virtual path site mappings
   * @returns {siteName: string, lang: string, country: string, url: string}
   */
  function stripVirtualPath(fPath, vPath, sitesObject) {
    if (
      typeof vPath === undefined ||
      vPath === null ||
      !sitesObject.get(vPath)
    ) {
      return sitesObject.get('default');
    }
    const siteProps = {
      ...sitesObject.get(vPath),
      url: fPath.replace(`/${vPath}`, ''),
    };
    // prepend slash if not exists - necessary for paths that rewrite home items
    // E.g. /brand-hub -> brand
    if (siteProps.url.substr(0, 1) !== '/') {
      siteProps.url = `/${siteProps.url}`;
    }
    return siteProps;
  }

  const match = reqUrl.match(
    /(^\/brand-hub)|(\/[a-z]{2}\/[a-z]{2}($|\/))|(\/[a-z]{2}($|\/))|\/(emea|global|apac|mdr)\/[a-z]{2}($|\/)/,
  );
  const virtualPath =
    typeof match === undefined || match === null
      ? null
      : match[0].replace(/^\/|\/$/g, '');

  return stripVirtualPath(reqUrl, virtualPath, sitesMap);
}
